import { render, staticRenderFns } from "./PrizeSaver.vue?vue&type=template&id=8f4e5376&scoped=true&"
import script from "./PrizeSaver.vue?vue&type=script&lang=js&"
export * from "./PrizeSaver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4e5376",
  null
  
)

export default component.exports